import { Box } from '@mui/material';
import { Outlet } from 'react-router-dom';

function CostTrackingLayout() {
  return (
    <Box
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        mr: 2,
      }}
    >
      <Outlet />
    </Box>
  );
}
export default CostTrackingLayout;
